import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PropertiesService } from '../../services/properties.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  standalone: false
})
export class HomeComponent implements OnInit {
  propiedades: any;

  constructor(private router: Router, private propServ: PropertiesService) {}

  ngOnInit(): void {
    let fil: any = {
      tipoOpe: 'ALL',
      tipoPr: 'ALL',
      localidad: 'ALL',
      barrio: 'ALL',
      dormitorio: 'ALL',
      cochera: false,
      patio: false,
      apCredito: false,
      from: 0,
      to: 5
    };

    localStorage.setItem('filter', JSON.stringify(fil));

    this.propServ.getPropiedades(
      fil.tipoOpe,
      fil.tipoPr,
      fil.localidad,
      fil.barrio,
      fil.dormitorio,
      fil.cochera,
      fil.patio,
      fil.apCredito,
      fil.from,
      fil.to
    ).subscribe((data: any[]) => {
      this.propiedades = data;
    });
  }

  getSearch(filter: any) {
    localStorage.setItem('filter', JSON.stringify(filter));
    if (filter.tipoOpe === 'VENTA') {
      this.router.navigate(['/venta']);
    } else if (filter.tipoOpe === 'ALQUILER') {
      this.router.navigate(['/alquiler']);
    } else if (filter.tipoOpe === 'ALL') {
      this.router.navigate(['/ALL']);
    }
  }

  goToDetail(img: any) {
    if (img?.propiedadId) {
      this.router.navigate(['/propiedad', img.propiedadId]);
    }
  }
}
